import { cn } from '@navinc/base-react-components'

import { LexicalSerializeChildren, serializeLexical } from './lexicalSerialize.jsx'
import { articleRichTextPreset } from './nodeClassNames.js'

export type LexicalRichTextContent = { root: { children: LexicalSerializeChildren } }

type LexicalRichTextProps = {
  content: LexicalRichTextContent
  preset?: keyof typeof presets | 'none' | null
  className?: string
}

const presets = {
  article: articleRichTextPreset,
}

export const LexicalRichText = ({ content, preset, className }: LexicalRichTextProps) => {
  if (!content) {
    return null
  }

  const nodeClassNames = preset && preset !== 'none' ? presets[preset].nodeClassNames : undefined

  // I don't think any of these classes are needed as they should be the defaults for a div
  return (
    <div className={cn('first:mt-0 last:mb-0 w-full', className)}>
      {serializeLexical(content.root.children, { nodeClassNames })}
    </div>
  )
}
